import React, { useState } from 'react'
import '../../Organisms/single-page-common/single-page-content-header.scss'
import { ButtonWithIcon } from '../../Atoms/Buttons/ButtonWithIcon'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import { ArchivePopup } from '../../Organisms/Popups/General/ArchivePopup'
import { toast } from 'react-toastify'
import { handleError } from '../../../utils/handleErrors'
import { updateEntity } from '../../../store/common/api'
import { createSubProductCatalog } from '../../../store/subProductCatalog/api'
const entityType = 'subCatalog'

export const Header = ({
    entity,
    updateInfo,
    entityURL = 'sub-product-catalogs',
}) => {
    const history = useHistory()
    const params = useParams()
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)
    const type = searchParams.get('type') ?? null
    const [archivePopup, setArchivePopup] = useState(false)
    const [approvalPopup, setApprovalPopup] = useState(false)
    const cancel = () => {
        history.push(`/${entityURL}`)
        setArchivePopup(false)
    }
    const approve = () => {
        // TODO: need to call to appreove
        setApprovalPopup(false)
        toast.success('SubProductCatalog sent to check')
    }
    const save = () => {
        createSubProductCatalog({ ...entity, modelId: params.modelId })
            .then(() => {
                history.push(`/${entityURL}`)
                toast.success('Successfully Created')
            })
            .catch(handleError)
    }
    const edit = () => {
        updateEntity(params.id, entityType, {
            name: entity.name,
            parent: entity.parent,
            internalId: entity.internalId,
            rules: entity.rules,
            globalParameters: entity.globalParameters,
            calculationBlocks: entity.calculationBlocks,
            crossSaleParameters: entity.crossSaleParameters,
            description: entity.description,
            modelId: entity.modelId,
        })
            .then(() => {
                updateInfo(params.id)
                toast.success('Successfully Updated')
            })
            .catch(handleError)
    }

    const handleSaveOrEdit = entity.id ? edit : save

    return (
        <>
            <ArchivePopup
                isOpen={archivePopup}
                togglePanel={setArchivePopup}
                onDelete={cancel}
                text="Are you sure you want to cancel"
            ></ArchivePopup>
            <ArchivePopup
                isOpen={approvalPopup}
                togglePanel={setApprovalPopup}
                onDelete={approve}
                text="Are you sure you want to send to approve"
            ></ArchivePopup>
            <div className="single-page-content-header">
                <div className="title">
                    <span>{entity.name}</span>
                </div>
                {!type ? (
                    <div className="actions">
                        <ButtonWithIcon
                            onClick={() => setArchivePopup(true)}
                            icon="/assets/images/Delete.png"
                            red={true}
                            value="Cancel"
                        />
                        <ButtonWithIcon
                            onClick={handleSaveOrEdit}
                            value="Save"
                            green={true}
                        />
                        {/*<ButtonWithIcon*/}
                        {/*    onClick={() => setApprovalPopup(true)}*/}
                        {/*    green={true}*/}
                        {/*    value="Send To Approval"*/}
                        {/*/>*/}
                    </div>
                ) : null}
            </div>
        </>
    )
}
